export enum CareerPathType {
  SCHOOL_EDUCATION = 'school_education',
  APPRENTICESHIP = 'apprenticeship',
  STUDIES = 'studies',
  WORK_EXPERIENCE = 'work_experience',
}
